module.exports = __webpack_public_path__ + "ionicons.2c2ae068be3b089e0a5b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ionicons/fonts/ionicons.eot?v=2.0.0
// module id = 258
// module chunks = 8